import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';



import { NgbModal, NgbModalOptions, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, ApplicationRef, ChangeDetectorRef } from '@angular/core';

@Component({
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title | translate }}</h4>
      <a class="link" aria-label="Close" (click)="activeModal.dismiss('')">
        <i class="icon icon-close-circle"></i></a>
    </div>
    <div class="modal-body text-center warning-modal">
      <div><i class="icon icon-danger-circle-outline"></i></div>
      <p>{{message|translate}}</p>
      <p>{{infoExtra|translate}}</p>
      <input *ngIf="content" type="password" [(ngModel)]="valueInput" class="form-control">
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="activeModal.close(false)">{{'CLOSE'|translate}}</button>
      <button type="button" class="btn btn-danger" *ngIf="action && !content" (click)="activeModal.close(true)">{{'CONFIRM'|translate}}</button>
      <button type="button" class="btn btn-danger" *ngIf="action && content" (click)="activeModal.close({Ok: true, value: valueInput})">{{'CONFIRM'|translate}}</button>
    </div>
  `
})
export class ConfirmComponent implements OnInit {
  @Input() title;
  @Input() message;
  @Input() infoExtra;
  @Input() action;
  @Input() content;

  valueInput = "";

  constructor(
    public activeModal: NgbActiveModal,
    public changeRef: ChangeDetectorRef
  ) { }
  ngOnInit() {
  }
}

@Injectable()
export class ConfirmService {

  constructor(private modalService: NgbModal) { }

  public confirm(message, infoExtra = '', content = false) {
    const modalRef = this.modalService.open(ConfirmComponent, { centered: true });
    modalRef.componentInstance.title = 'CONFIRMATION';
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.infoExtra = infoExtra;
    modalRef.componentInstance.action = true;
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.changeRef.markForCheck();
    return modalRef.result;
  }

  public warnning(message, title = '', action = false) {
    const modalRef = this.modalService.open(ConfirmComponent, { centered: true });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.changeRef.markForCheck();
    return modalRef.result;
  }

}
